<template>
    <div class="faq-page">
      <h1>常见问题 (FAQ)</h1>
      <div class="faq-item" v-for="(faq, index) in faqs" :key="index">
        <h2>{{ faq.question }}</h2>
        <p>{{ faq.answer }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "FaqPage",
    data() {
      return {
        faqs: [
          {
            question: "1. 如何使用在线PDF转DOC工具？",
            answer: "只需点击上传按钮，选择需要转换的PDF文件，然后点击“转换”即可。转换完成后，您可立即下载转换后的Word文档。"
          },
          {
            question: "2. 转换后的文件格式是否正确？",
            answer: "经过多次测试，与其它pdf.net转换网站相比，我们的工具能更准确地保留原文件格式，确保内容排版和格式输出接近原文件。"
          },
          {
            question: "3. 是否可以去除背景水印？",
            answer: "是的，转换过程中您可以选择去除背景水印，输出的文档将更加干净、易于编辑。"
          },
          {
            question: "4. 网站支持哪些文件格式转换？",
            answer: "目前主要支持PDF转DOC转换，后续将持续优化并扩展更多文件格式转换功能。"
          },
          {
            question: "5. 网站的安全性如何？",
            answer: "我们非常重视用户数据的安全性。所有上传文件均采用加密传输，并在转换完成后，用户可以转换列表下载或删除数据，用户不删除的系统会定时清除数据，确保您的隐私安全。"
          },
          {
            question: "6. 网站是如何开发的？",
            answer: "该网站采用Vue框架开发，具有响应式设计和良好的前端性能，确保在各种设备上均有出色的用户体验。"
          },
          {
            question: "7. 如果遇到问题该如何解决？",
            answer: "若在使用过程中遇到任何问题，请通过在线客服或发送邮件至qyhua0@hotmail.com联系我们，我们将为您提供及时帮助。"
          }
        ]
      }
    }
  }
  </script>
  
  <style scoped>
  .faq-page {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
  }
  
  .faq-page h1 {
    text-align: center;
    margin-bottom: 30px;
  }
  
  .faq-item {
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
  }
  
  .faq-item h2 {
    font-size: 1.5em;
    margin-bottom: 10px;
    color: #333;
  }
  
  .faq-item p {
    font-size: 1em;
    line-height: 1.6;
    color: #666;
  }
  </style>
  